import { render } from "./ListaDeseos.vue?vue&type=template&id=25eb675d"
import script from "./ListaDeseos.vue?vue&type=script&lang=js"
export * from "./ListaDeseos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__